import type { TFunction } from "i18next";

export type SupportedLocales = "en-CA" | "fr-CA";
export const SUPPORTED_LOCALES = ["en-CA", "fr-CA"] as SupportedLocales[];
/**
 * This should be provided by platform
 */
export const DEFAULT_LOCAL = "en-CA";

export function isSupportedLocale(locale: string): locale is SupportedLocales {
  return locale === "en-CA" || locale === "fr-CA";
}

export function resolveTextEditorSupportedLocalesTranslation(
  t: TFunction,
  localeCode: SupportedLocales
) {
  const localeMap: Record<SupportedLocales, string> = {
    "en-CA": t("common.components.localizedTextEditor_localeEnum_enCa"),
    "fr-CA": t("common.components.localizedTextEditor_localeEnum_frCa"),
  };

  return localeMap[localeCode] ?? "-";
}
